/**
 * Expands type aliases to show all fields in IDE tooltips.
 *
 * Forces TypeScript to display the full structure instead of just the type name.
 * Useful for improving developer experience with complex union types.
 *
 * @example
 * ```ts
 * type User = { name: string } & { age: number }
 * type ExpandedUser = Expand<User> // Shows: { name: string; age: number }
 * ```
 */
export type Expand<T> = T extends infer O ? { [K in keyof O]: O[K] } : never
